import { render, staticRenderFns } from "./UploaderAvatar.vue?vue&type=template&id=320fb8f6&scoped=true&"
import script from "./UploaderAvatar.vue?vue&type=script&lang=js&"
export * from "./UploaderAvatar.vue?vue&type=script&lang=js&"
import style0 from "./UploaderAvatar.vue?vue&type=style&index=0&id=320fb8f6&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320fb8f6",
  null
  
)

export default component.exports